import React, { useEffect, useState } from 'react';
import { SelectInput } from '../../../Components';
import Calculator from '../Calculator';
import './Index.css';
const productPrice = {
    'T-Shirt': 150,
    Hoodie: 500,
};
const Index = ({ product, deliverycost }) => {
    const [printType, setPrintType] = useState('null');
    const [customPrice, setCustomItemPrice] = useState(productPrice[product]);
    useEffect(() => {
        setPrintType('null');
        setCustomItemPrice(productPrice[product]);
    }, [product]);
    useEffect(() => {
        setCustomItemPrice(productPrice[product]);
    }, [printType]);
    return (
        <>
            <div className="merch_printtype">
                <SelectInput
                    label="Print Type"
                    outlined={true}
                    value={printType}
                    changeHandler={(e) => {
                        setPrintType(e.target.value);
                    }}
                    options={
                        product === 'T-Shirt'
                            ? [
                                  { name: 'Select a Print Type', value: 'null' },
                                  { name: 'Screen Print Design', value: 'Screen Print Design' },
                                  { name: 'Sublimation Print Design', value: 'Sublimation Print Design' },
                                  { name: 'Digital print design', value: 'Digital print design' },
                                  { name: 'Vinyl Printing', value: 'Vinyl Printing' },
                                  { name: 'UV printing', value: 'UV printing' },
                              ]
                            : [
                                  { name: 'Select a Print Type', value: 'null' },
                                  { name: 'Screen Print Design', value: 'Screen Print Design' },
                                  { name: 'Digital print design', value: 'Digital print design' },
                                  { name: 'Vinyl Printing', value: 'Vinyl Printing' },
                                  { name: 'UV printing', value: 'UV printing' },
                              ]
                    }
                />
            </div>
            {printType !== 'null' && (
                <div className="print_type_details">
                    <Calculator
                        deliverycost={deliverycost}
                        product={product}
                        printType={printType}
                        itemPrice={productPrice[product]}
                        setItemPrice={setCustomItemPrice}
                    />
                </div>
            )}
            {customPrice !== productPrice[product] && (
                <div className="pricing_total_merch" style={{ display: 'flex', flexDirection: 'column' }}>
                    <p className="MP-P MGT2">
                        <span>{product} Price With Printing:</span> {customPrice}₹
                    </p>

                    <p style={{ margin: '0 !important' }} className="input_info">
                        Includes Delivery Cost( {deliverycost}₹ ) and 5% GST
                    </p>
                </div>
            )}
        </>
    );
};

export default Index;
